import React, { useCallback, useEffect, useState, FC } from 'react';

import Typography from '@material-ui/core/Typography';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import cx from 'classnames';

import ScreenRotationIcon from '../../assets/icons/ScreenRotationIcon';
import { useEventListener } from '../../utils/hooks';
import useStyles from './styles';

interface RotateYourPhoneCTAProps {
  width: Breakpoint;
  minRequiredWidth?: number;
  title: string;
  wrapperClass?: string;
}

const RotateYourPhoneCTA: FC<RotateYourPhoneCTAProps> = ({
  width,
  minRequiredWidth = 0,
  title,
  wrapperClass,
}) => {
  const classes = useStyles();
  const [screenHeight, setScreenHeight] = useState(0);
  const isMobile = !isWidthUp('md', width);

  const setScreenHeightHandler = useCallback(() => {
    if (window) {
      const screenHeight = window?.screen?.height;
      setScreenHeight(screenHeight);
    }
  }, []);

  useEffect(() => {
    setScreenHeightHandler();
  }, [setScreenHeightHandler]);

  useEventListener('resize', setScreenHeightHandler);

  const isEnoughSpace = isMobile && screenHeight > minRequiredWidth;

  if (!isEnoughSpace) return null;

  return (
    <div className={cx(classes.rotateWrapper, wrapperClass)}>
      <ScreenRotationIcon className={classes.rotateIcon} />

      <Typography variant="h3" component="h3" align="center" className={classes.rotateTitle}>
        {title}
      </Typography>
    </div>
  );
};

export default withWidth()(RotateYourPhoneCTA);
